import ReactDOM from "react-dom";
import { importMap } from "./importMap";


export const getComponentDetailsFromDOM = (componentName: string) => {

  try {
    const targetNodeList = document.querySelectorAll(
      `[data-component="${componentName}"]`
    );
    const targetNodeArray = [];
    // eslint-disable-next-line no-plusplus
    for (
      let i = 0, ll = targetNodeList.length;
      i !== ll;
      targetNodeArray.push(targetNodeList[i++])
    );
    if (targetNodeArray && targetNodeArray.length) {
      return targetNodeArray.map((targetNode) => {
        const props = targetNode.getAttribute("data-props");
        return {
          targetNode,
          props: props ? JSON.parse(props) : null,
        };
      });
    }
  } catch (err) {
    console.error(
      "There was an error when getting component details from DOM for:",
      { componentName, err }
    );
    return false;
  }
  return false;
};

export const render = ({
  componentName,
  getComponent,
  eventListener,
  skipInit = false,
}: {
  componentName: string;
  getComponent: () => Promise<{
    [key: string]: any;
  }>;
  eventListener?: string;
  skipInit?: boolean;
}) => {
  const componentDetailsList = getComponentDetailsFromDOM(componentName);
  if (componentDetailsList && componentDetailsList.length && !skipInit) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = componentDetailsList.length; i < len; i++) {
      const { targetNode, props } = componentDetailsList[i];
      getComponent()
        .then((module) => {
          const Component = module[componentName];
          try {
            ReactDOM.render(<Component {...props} />, targetNode);
          } catch (err) {
            console.error(
              "Dynamically loaded component is not valid:",
              { componentName, err },
              Component
            );
          }
        })
        .catch((err) => {
          console.error("Could NOT load the component dynamically:", {
            componentName,
            err,
          });
        });
    }
  }
  if (eventListener) {
    document.addEventListener(eventListener, () => {
      render({ componentName, getComponent });
    });
  }
};

const loadComponents = () => {
  Object.entries(importMap).forEach(
    ([componentName, { getComponent, eventListener, skipInit }]) => {
      render({
        getComponent,
        componentName,
        eventListener,
        skipInit,
      });
    }
  );
};

loadComponents();

document.addEventListener("shopify:section:load", () => {
  loadComponents();
});
